import { modalStore } from '~/providers/modal.provider';

export const isSmartFileSetupWizardModalOpen = () => {
    return modalStore.isModalOpen('smart-file-setup-wizard');
};
